import React, { Component } from 'react';
import { connect } from 'react-redux';
import BuyButton from '../Components/BuyButton';
import { receive, loadError, addToCartError, clearCartError } from '../Actions/Cart.action';
import { clearSizeInputData } from '../Actions/PurchaseMultiSizeInput.action';
import { catchError } from '../Actions/Error.action';
import { add as addToCartService} from '../Services/Cart.service';
import withReactiveStyleBuyButton from './withReactiveStyleBuyButton';
import { addToCartEvent } from '../wooscripts/gtmEnchanced';
import { translate } from '../Services/translation';
import { object, array, ValidationError } from 'yup';

const buyArticlesSchema = object().shape({
    articles: array().min(1, translate(`addtocart.minimumone`))
        .test('QuantityTest', '', function test(articles) {
            const articleErrors = articles.map((article) => {
                if (article.quantity <= article.maxQuantity || !article.maxQuantity) 
                    return null
        
                return new ValidationError(
                    translate('sizeInput.tooMany'),                 // Message
                    article.fieldId,                                // Value
                    `articleSizeInputField.${article.fieldId}`      // Path
                  
                )
            }).filter(Boolean)

            if (articleErrors.length === 0) 
                return true

            return this.createError({
                message: () => articleErrors
            })
        })
});

class BuyButtonContainer extends Component {
    constructor(props) {
        super(props);
    }

    buyItems() {
        const articlesToPurchase = this.props.articlesToPurchase
        
        if (document.body.classList.contains('casall-pro')) {            
            this.props.onClick(articlesToPurchase);
        }
        else {
            buyArticlesSchema.validate(articlesToPurchase, {context: articlesToPurchase})
            .then(() => {
                this.props.onClick(articlesToPurchase);
            })
            .catch((error) => {
                this.props.addToCartError(error);
            })
        }        
    }

    render() {
        const enableOnClick = (this.props.articlesToPurchase || this.props.articleNumber) && !this.props.href

        return (
            <BuyButton {...{...this.props, enableOnClick} }
                onClick={() => {
                    this.buyItems();
                }} />
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    // Multiple size purchase
    const sizeInputData = state.sizeInput;

    // Single size purchase
    const quantityFieldId = ownProps.quantityFieldId
    const quantity = quantityFieldId ? document.getElementById(quantityFieldId).value : 1;
    const articlenumber = ownProps.articleNumber;

    const articlesToPurchase = sizeInputData.data.length > 0 ? sizeInputData.data
        .filter(item => item.fieldValue > 0)
        .map(item =>  (
            {
                articleNumber: item.articleNumber,
                quantity: item.fieldValue,
                maxQuantity: item.availableInStock, // For validation
                fieldId: item.fieldId               // For validation
            }
        ))
        : [{
            articleNumber: articlenumber,
            quantity: quantity,
        }]

    return { 
        articlesToPurchase: { articles: articlesToPurchase }
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addToCartError: (error) => dispatch(addToCartError(error)),
        onSuccess: (cart) => {
            dispatch(clearCartError())
            dispatch(clearSizeInputData())
            dispatch(receive(cart));
        },
        onError: (ex) => {
            dispatch(catchError(ex, error => loadError(error)));
        }
    }
}

const onClick = (articlesToPurchase) => {
    return addToCartService(articlesToPurchase.articles);
}

export default connect(mapStateToProps, mapDispatchToProps)(
            withReactiveStyleBuyButton(BuyButtonContainer, onClick, 'buy-button-container', translate('product.addedtocart')));
